import React from 'react'
// @ts-ignore
import classnames from 'classnames'
import { DynamicImageCompoundProps } from './DynamicImageCompound.types'

export const DynamicImageCompound = (props: DynamicImageCompoundProps) => {
  const { imageDesktop, imageMobile, template } = props

  const getProperty = (
    property: 'src' | 'alt' | 'title' | 'imagePosition' | 'url',
    type: string
  ) => {
    const imageDesk = imageDesktop || {}
    const imageMob = imageMobile || {}
    if (type === 'mobile') {
      return property in imageMob ? imageMob[property] : imageDesk[property]
    }
    return imageDesk[property]
  }
  const imageStyle =
    getProperty('imagePosition', 'desktop') === 'full'
      ? ' u-sizeFull '
      : getProperty('imagePosition', 'desktop') === 'fullHeight'
      ? ' u-sizeFull u-screenHeight '
      : ''
  const dlgStyle = template === 'Microsite' ? 'u-screenHeight' : ''
  return (
    <>
      {getProperty('url', 'desktop') ? (
        <a className='u-inlineBlock' href={getProperty('url', 'desktop')}>
          <picture className='image-block'>
            <source srcSet={getProperty('src', 'mobile')} media='(max-width: 1024px)' />

            <img
              src={getProperty('src', 'desktop')}
              alt={getProperty('alt', 'desktop')}
              title={getProperty('title', 'desktop')}
              className={imageStyle + dlgStyle}
            />
          </picture>
        </a>
      ) : (
        <picture className='image-block'>
          <source srcSet={getProperty('src', 'mobile')} media='(max-width: 1024px)' />

          <img
            src={getProperty('src', 'desktop')}
            alt={getProperty('alt', 'desktop')}
            title={getProperty('title', 'desktop')}
            className={imageStyle + dlgStyle}
          />
        </picture>
      )}
    </>
  )
}
